const initialState = {};

export default (state = initialState, action) => {
	switch (action.type) {
		// ===================================
		//  GET
		// ===================================
		case "NEWS_PAGINATION_IS_LOADING":
			return {
				...state,
				isLoading: 1
			};
		case "NEWS_PAGINATION_HAS_ERROR":
			return {
				...state,
				isLoading: 0,
				error: action.error
			};
		case "NEWS_PAGINATION_SUCCESS":
			return {
				...state,
				...action.data.data,
				isLoading: 0
			};

		// ===================================
		//  CLEAR
		// ===================================
		case "NEWS_PAGINATION_CLEAR":
			return {};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/newsPagination.js